export const navLinks = [
  { label: 'Home', href: '#top' },
  { label: 'Cases', href: '#cases' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Bastidores', href: '#bastidores' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Blog', href: '#top' },
  { label: 'Contato', href: '#contato' },
];

const V2_LOGOS = '/v2_logos';

export const v2BrandLogo = `${V2_LOGOS}/NapalmLogo_big.png`;
export const v2YearsBadge = `${V2_LOGOS}/18YEARS.png`;

const COMPANY_LOGOS = '/company logos';

export const previewLogos = [
  { name: 'Coca-Cola', src: `${COMPANY_LOGOS}/Coca-Cola_logo_white.png` },
  { name: "McDonald's", src: `${COMPANY_LOGOS}/McDonalds_logo_longo.png` },
  { name: 'Unilever', src: `${COMPANY_LOGOS}/Unilever.svg` },
  { name: 'Renner', src: `${COMPANY_LOGOS}/Logotipo_das_Lojas_Renner.svg` },
  { name: 'Tramontina', src: `${COMPANY_LOGOS}/Tramontina_logo_91451b3262.svg` },
  { name: 'Natura', src: `${COMPANY_LOGOS}/natura_-_orange_-_horizontal.png` },
  { name: 'YouCom', src: `${COMPANY_LOGOS}/YOUCOM.png` },
  { name: 'Toyota', src: `${COMPANY_LOGOS}/logo-toyota.svg` },
  { name: 'JBL', src: `${COMPANY_LOGOS}/jbl-logo.svg` },
  { name: 'Fruki', src: `${COMPANY_LOGOS}/fruki.png` },
];

const V2_VIDEOS = '/v2_videos';
const V2_MAKING_OFF = `${V2_VIDEOS}/making_off`;

export const makingOffVideos = [
  {
    title: 'Kolosh',
    description: 'Making of / bastidores.',
    video: `${V2_MAKING_OFF}/Kolosh_Making_OFF.mp4`,
  },
  {
    title: 'YouCom',
    description: 'Making of / bastidores.',
    video: `${V2_MAKING_OFF}/HD_YouCom_ Making_OFF.mp4`,
  },
];

export const previewCases = [
  {
    title: 'Coca-Cola',
    category: 'OOH 3D Experience',
    description:
      'Experiência imersiva em mídia out-of-home com personagem 3D em grande escala, criando impacto visual instantâneo na rua.',
      longDescription: `Projeto muito especial desenvolvido para agência W3 para a Coca cola. Experiência imersiva em mídia out-of-home da Imobi na avenida Nilo Peçanha com personagem 3D em grande escala, criando impacto visual instantâneo na rua. 

Painel em OOH 3D de Natal para a Coca Cola, painel da Imobi em Porto Alegre, Brazil.
Marca: Coca Cola
Agência: W3
Animação: Napalm Studio`,
    image: '/not_used/images/Coca_cola_HD.mp4_snapshot_00.11.998.jpg',
    video: `${V2_VIDEOS}/Coca_cola_HD.mp4`,
  },
  {
    title: 'Renner',
    category: 'Fashion Experience',
    description:
      'Narrativa visual premium para moda, com foco em textura, movimento e presença de marca em campanhas digitais.',
    longDescription:
      `Projeto muito especial desenvolvido para agência Paim para a Renner. Experiência imersiva em mídia out-of-home da Imobi na avenida Nilo Peçanha. Narrativa visual premium para moda, com foco em textura, movimento e presença de marca em campanhas digitais.

Painel em OOH 3D para as lojas Renner, painel da Imobi em Porto Alegre, Brazil.

Marca(Brand): Renner
Agência: Paim
Animação: Napalm Studio`,
    image: '/not_used/images/Painel_RENNER.mp4_snapshot_00.04.626.jpg',
    video: `${V2_VIDEOS}/RENNER_NILO_2.mp4`,
  },
  {
    title: 'Tramontina',
    category: 'Product Animation',
    description:
      'Animação de produto com acabamento fotorealista para destacar design, material e performance em campanhas comerciais.',
    longDescription:
      `Projeto muito especial desenvolvido para agência W3 para a Tramontina. Experiência imersiva em mídia out-of-home da Imobi na avenida Nilo Peçanha. Animação de produto com acabamento fotorealista para destacar design, material e performance em campanhas comerciais.

Painel em OOH 3D para a Tramontina, painel da Imobi em Porto Alegre, Brazil.

Marca(Brand): Tramontina
Agência: W3
Animação: Napalm Studio`,
    image: '/not_used/images/Tramontina_HD_1.mp4_snapshot_00.09.702.jpg',
    video: `${V2_VIDEOS}/Tramontina_2025.mp4`,
  },
];

export const previewServices = [
  { id: '01', title: 'Animação 3D', icon: 'cube' },
  { id: '02', title: 'VFX', icon: 'spark' },
  { id: '03', title: 'Publicidade', icon: 'megaphone' },
  { id: '04', title: 'OOH', icon: 'screen' },
  { id: '05', title: 'Branded Experiences', icon: 'target' },
  { id: '06', title: 'Visual Development', icon: 'pencil' },
];

export const previewStats = [
  { value: '18+', label: 'Anos de mercado' },
  { value: '300+', label: 'Projetos entregues' },
  { value: '50+', label: 'Marcas parceiras' },
];

/** Brazil +55, area 51, mobile 992967386 */
export const whatsappUrl =
  'https://wa.me/5551992967386?text=' +
  encodeURIComponent('Olá! Gostaria de conversar sobre um projeto com a Napalm Studio.');

const SOCIAL_LOGOS = '/social media logos';

export const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/napalmstudio.br/', icon: `${SOCIAL_LOGOS}/Instagram.svg` },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/napalm-studio/', icon: `${SOCIAL_LOGOS}/linkedin.svg` },
  { label: 'YouTube', href: 'https://www.youtube.com/@NapalmStudioGames', icon: `${SOCIAL_LOGOS}/youtube.svg` },
  { label: 'Behance', href: 'https://www.behance.net/napalmstudio_br', icon: `${SOCIAL_LOGOS}/behance.svg` },
];
